<template>
  <v-container class="py-0 px-0 px-md-3" fluid>
    <!-- <v-row>
      <v-col cols="12">
        <v-text-field
          solo-inverted
          hide-details
          clearable
          prepend-inner-icon="mdi-magnify"
          label="Buscar"
          v-model="search.query"
          v-if="showSearch"
        ></v-text-field>
        <v-menu
          v-model="search.datesMenu"
          :close-on-content-click="false"
          :nudge-right="40"
          min-width="240px"
          transition="scale-transition"
          offset-y
          v-if="showSearch"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
              v-model="searchDateRangeText"
              label="Rango de Fechas"
              prepend-inner-icon="event"
              flat
              solo-inverted
              hide-details
              clearable
              readonly
              v-bind="attrs"
              v-on="on"
              width="200"
            ></v-text-field>
          </template>
          <v-date-picker v-model="search.dates" no-title range>
            <v-spacer></v-spacer>
            <v-btn text color="primary" @click="search.datesMenu=false; search.dates=[]">Cancel</v-btn>
            <v-btn text color="primary" @click="search.datesMenu=false">OK</v-btn>
          </v-date-picker>
        </v-menu>
      </v-col>
    </v-row>-->
    <v-row v-if="dashboardData.chart1">
      <v-col cols="12">
        <component
          v-bind:is="dashboardData.chart1.type"
          :title="dashboardData.chart1.title"
          :options="dashboardData.chart1.options"
          @filter="filter"
        ></component>
      </v-col>
    </v-row>
    <v-row v-if="dashboardData.chart2">
      <v-col cols="12">
        <component
          v-bind:is="dashboardData.chart2.type"
          :title="dashboardData.chart2.title"
          :options="dashboardData.chart2.options"
          @filter="filter"
        ></component>
      </v-col>
    </v-row> 
    <v-row v-if="dashboardData.chart3">
      <v-col cols="12">
        <component
          v-bind:is="dashboardData.chart3.type"
          :title="dashboardData.chart3.title"
          :options="dashboardData.chart3.options"
          @filter="filter"
        ></component>
      </v-col>
    </v-row>
    <v-row v-if="dashboardData.chart4">
      <v-col cols="12">
        <component
          v-bind:is="dashboardData.chart4.type"
          :title="dashboardData.chart4.title"
          :options="dashboardData.chart4.options"
          @filter="filter"
        ></component>
      </v-col>
    </v-row>
    <v-row v-if="dashboardData.chart5">
      <v-col cols="12">
        <component
          v-bind:is="dashboardData.chart5.type"
          :title="dashboardData.chart5.title"
          :options="dashboardData.chart5.options"
          @filter="filter"
        ></component>
      </v-col>
    </v-row>
    <v-row v-if="dashboardData.chart6">
      <v-col cols="12">
        <component
          v-bind:is="dashboardData.chart6.type"
          :title="dashboardData.chart6.title"
          :options="dashboardData.chart6.options"
          @filter="filter"
        ></component>
      </v-col>
    </v-row>
    <v-row v-if="dashboardData.chart7">
      <v-col cols="12">
        <component
          v-bind:is="dashboardData.chart7.type"
          :title="dashboardData.chart7.title"
          :options="dashboardData.chart7.options"
          @filter="filter"
        ></component>
      </v-col>
    </v-row>
    <v-row v-if="dashboardData.chart8">
      <v-col cols="12">
        <component
          v-bind:is="dashboardData.chart8.type"
          :title="dashboardData.chart8.title"
          :options="dashboardData.chart8.options"
          @filter="filter"
        ></component>
      </v-col>
    </v-row>
    <v-row v-if="dashboardData.chart9">
      <v-col cols="12">
        <component
          v-bind:is="dashboardData.chart9.type"
          :title="dashboardData.chart9.title"
          :options="dashboardData.chart9.options"
          @filter="filter"
        ></component>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import DashboardMixin from "@/components/mixins/dashboard.js";
import { generateDayWiseTimeSeries } from "@/commons/chart-commons.js";

export default {
  mixins: [DashboardMixin],
  data() {
    return {
      showSearch: true,
      search: {
        query: "",
        datesMenu: false,
        dates: [],
      },
      chart1: {
        type: "word-cloud",
        title: "WordCloud",
        options: {
          words: [
            ["romance", 19],
            ["horror", 3],
            ["fantasy", 7],
            ["adventure", 3],
            ["terror", 13],
            ["mistery", 11],
            ["fiction", 8],
            ["comedy", 2],
            ["drama", 12],
            ["family", 5],
            ["sci-fi", 6],
          ],
        },
      },
      chart2: {
        type: "vis-network",
        title: "Network",
        options: {
          nodes: [
            { id: 1, label: "circle", shape: "diamond" },
            { id: 2, label: "ellipse", shape: "ellipse" },
            { id: 3, label: "database", shape: "database" },
            { id: 4, label: "box", shape: "box" },
            { id: 5, label: "diamond", shape: "diamond" },
            { id: 6, label: "dot", shape: "dot" },
            { id: 7, label: "square", shape: "square" },
            { id: 8, label: "triangle", shape: "triangle" },
          ],
          edges: [
            { from: 1, to: 2 },
            { from: 2, to: 3 },
            { from: 2, to: 4 },
            { from: 2, to: 5 },
            { from: 5, to: 6 },
            { from: 5, to: 7 },
            { from: 6, to: 8 },
          ],
        },
      },
      chart3: {
        type: "pie-chart",
        title: "Pie",
        options: {
          categories: ["Positive", "Negative", "Neutral"],
          colors: ["#34bf49", "#ff4c4c", "#b9c0c5"],
          fill: {
            opacity: 0.88,
          },
          series: [44, 55, 13],
        },
      },
      chart4: {
        type: "stacked-bar-chart",
        title: "Stacker Bar",
        options: {
          categories: [2008, 2009, 2010, 2011, 2012, 2013, 2014],
          series: [
            {
              name: "Marine Sprite",
              data: [44, 55, 41, 37, 22, 43, 21],
            },
            {
              name: "Striking Calf",
              data: [53, 32, 33, 52, 13, 43, 32],
            },
            {
              name: "Tank Picture",
              data: [12, 17, 11, 9, 15, 11, 20],
            },
            {
              name: "Bucket Slope",
              data: [9, 7, 5, 8, 6, 9, 4],
            },
            {
              name: "Reborn Kid",
              data: [25, 12, 19, 32, 25, 24, 10],
            },
          ],
        },
      },
      chart5: {
        type: "line-chart",
        title: "Line",
        options: {
          categories: [
            "Jan",
            "Feb",
            "Mar",
            "Apr",
            "May",
            "Jun",
            "Jul",
            "Aug",
            "Sep",
          ],
          series: [
            {
              name: "Desktops",
              data: [10, 41, 35, 51, 49, 62, 69, 91, 148],
            },
            {
              name: "Desktops2",
              data: [10, 2, 55, 51, 49, 32, 99, 11, 148],
            },
          ],
        },
      },
      chart6: {
        type: "area-chart",
        title: "Area",
        options: {
          series: [
            {
              name: "South",
              data: generateDayWiseTimeSeries(
                new Date("11 Feb 2017 GMT").getTime(),
                20,
                {
                  min: 10,
                  max: 60,
                }
              ),
            },
            {
              name: "North",
              data: generateDayWiseTimeSeries(
                new Date("11 Feb 2017 GMT").getTime(),
                20,
                {
                  min: 10,
                  max: 20,
                }
              ),
            },
            {
              name: "Central",
              data: generateDayWiseTimeSeries(
                new Date("11 Feb 2017 GMT").getTime(),
                20,
                {
                  min: 10,
                  max: 15,
                }
              ),
            },
          ],
        },
      },
      chart7: {
        type: "bar-chart",
        title: "BarChart",
        options: {
          categories: [1991, 1992, 1993, 1994, 1995, 1996, 1997, 1998],
          series: [
            {
              name: "series-1",
              data: [30, 40, 45, 50, 49, 60, 70, 91],
            },
            {
              name: "series-2",
              data: [30, 10, 45, 50, 49, 60, 70, 91],
            },
          ],
        },
      },
      chart8: {
        type: "radial-chart",
        title: "Radial",
        options: {
          label: "label",
          value: 70,
        },
      },
      chart9: {
        type: "maps-marker",
        title: "Maps Marker",
        options: {
          points: [
            {
              position: { lat: 1.38, lng: 103.8 },
              title: "test",
              author: "alejandro",
              creationTime: "2020-06-06",
              media: "",
              content: "test content to be able to render a long tooltip",
              source: "template",
              url: "https://copra.com.co",
            },
            {
              position: { lat: 1.34, lng: 99.8 },
              title: "test",
              author: "alejandro",
              creationTime: "2020-06-06",
              media: "",
              content:
                "test content to be able to render a long tooltip, test content to be able to render a long tooltip test content to be able to render a long tooltip, test content to be able to render a long tooltip test content to be able to render a long tooltip.",
              source: "template",
              url: "https://copra.com.co",
            },
          ],
        },
      },
      chart10: {
        type: "maps-heat",
        title: "Maps Heat",
        options: {
          points: [
            { position: { lat: 1.38, lng: 103.8 } },
            { position: { lat: 1.34, lng: 99.8 } },
          ],
        },
      },
    };
  },
  mounted() {
    console.log(this.dashboardData);
  },
};
</script>
